import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ResizeObserver from 'resize-observer-polyfill';
import { ConnectedRouter } from 'connected-react-router';
import routes from './routes';
import { hotjar } from 'react-hotjar';

import Loading from './components/Loading';
import { postMessageSender } from './lib/postMessager';

class App extends Component {
  componentDidMount() {
    hotjar.initialize(
      process.env.REACT_APP_HOTJAR_ID,
      process.env.REACT_APP_HOTJAR_SNIPPET_VERSION,
    );

    const observer = new ResizeObserver(entries => {
      const [entry] = entries;

      const { height } = entry.contentRect;

      postMessageSender({ height: height + 30 });
    });

    observer.observe(document.body);
  }

  render() {
    return (
      <>
        <Loading />
        <ConnectedRouter history={this.props.history}>{routes}</ConnectedRouter>
      </>
    );
  }
}

App.propTypes = {
  history: PropTypes.object.isRequired,
};

export default App;
